
import SceneStore from './stores/scene';

let Router = null;

export function getPathName(){
    if(Router){
        return Router.location.pathname;
    }
}
export function initRouter(router){
    Router = router;
    setTimeout(() => {
        SceneStore.changeScene(router.location.pathname.slice(1));
    }, 300);
}
export function jumpTo(pathname){
    SceneStore.changeMasker('');   
    SceneStore.changeScene(pathname);
    Router.push(pathname);
}